import api from "./api";
import { config } from "./config.service";

const API_URL = config.host_api;

export const getProgressReportApprovalList = (id) => {
  return api
    .get(`${API_URL}progress-report-approval/${id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getProgressReportApprovalMoreDetail = (report_id, form_nm) => {
  return api
    .get(`${API_URL}progress-report/${report_id}/${form_nm}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getProgressReportApprovalListAdmin = () => {
  return api
    .get(`${API_URL}progress-report-approval/admin`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const confirmProgressReportApprovalListMentor = (report_id, confirm) => {
  return api
    .put(`${API_URL}progress-report/${report_id}/4/${confirm}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const confirmProgressReportApprovalListAdmin = (report_id, confirm) => {
  return api
    .put(`${API_URL}progress-report/${report_id}/5/${confirm}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const checkProgressReport = (user_id) => {
  return api
    .get(`${API_URL}progress-report-approval/check-progress-report/${user_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getProgressReportByStdId = (user_id) => {
  return api
    .get(`${API_URL}progress-report-approval/std/${user_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getProgressReportStatus = (user_id) => {
  return api
    .get(`${API_URL}progress-report-approval/status/${user_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};
